// src/utils/profile.js

const REQUIRED_PROFILE_FIELDS = ['displayName', 'username'];

/**
 * Merges profile data with safe defaults for form initialization.
 * @param {Object} profile - Existing profile data (may be partial or null)
 * @returns {Object} Complete profile object with all fields guaranteed
 */
export const mergeProfileDefaults = (profile = {}) => ({
  // Type-safe defaults prevent undefined values in forms
  displayName: typeof profile.displayName === 'string' ? profile.displayName : '',
  username: typeof profile.username === 'string' ? profile.username : '',
  bio: typeof profile.bio === 'string' ? profile.bio : '',
  profilePictureUrl:
    typeof profile.profilePictureUrl === 'string' ? profile.profilePictureUrl : '',
});

/**
 * Determines if profile has all required fields with valid values.
 * Total function: handles undefined, null, and partial objects safely.
 * @param {*} profile - Profile to check (may be any type)
 * @returns {boolean} True only if all required fields are non-empty strings
 */
export const isProfileComplete = (profile) => {
  if (!profile) return false; // Guard against null/undefined

  return REQUIRED_PROFILE_FIELDS.every((field) => {
    const value = profile[field];
    return typeof value === 'string' && value.trim().length > 0;
  });
};

export const getRequiredProfileFields = () => [...REQUIRED_PROFILE_FIELDS];

/**
 * Maps error objects to i18n keys for user-friendly messages.
 * @param {Error|null} error - Error from profile save operation
 * @returns {string|null} Translation key or null
 */
export const getProfileSubmitErrorKey = (error) => {
  if (!error) return null;

  const message = error?.message || '';

  if (message.includes('Username already taken')) {
    return 'profile.username_taken';
  }

  return 'profile.update_failed';
};
